import * as React from 'react';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../_pageWrappers/MemberPageWrapper';

export function DummyPage(): JSX.Element 
{
    return (
        <MemberPageWrapper breadCrumbs={[{ text: 'Dummy', url: '' }]}>
            <DummyPageContent />
        </MemberPageWrapper>
    );
}

function DummyPageContent(): JSX.Element
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['SuperAdmin']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <>
            <PageHeader 
                narrow
                headerIcon='survey_question'
                headerText="Dummy" headerStyle="secondary-gray"
            />

            <SingleColumnLayout narrow>
                <>
                    <span>{process.env.NODE_ENV}</span>
                </>
            </SingleColumnLayout>
        </>
    );
}

